if (!customElements.get('show-more')) {
  class ShowMore extends HTMLElement {
    constructor() {
      super();
      
      this.previewHeight = Number(this.dataset.previewHeight || "0");
      this.contentWrapper = this.querySelector('.gg-show-more__content');
      this.content = this.contentWrapper.querySelector('div');
      this.buttonWrapper = this.querySelector('.gg-show-more__button');
      this.button = this.buttonWrapper.querySelector('button');

      setTimeout(() => {
        this.init();
      }, 50);
    }

    init() {
      if (this.content.scrollHeight > this.previewHeight) {
        this.buttonWrapper.style.display = "block";
        setTimeout(() => {
          this.buttonWrapper.style.opacity = 1;
        }, 50);
      }

      this.button.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick() {
      if (this.dataset.open !== "true") {
        // open
        this.contentWrapper.style.height = `${this.content.scrollHeight}px`;
        this.dataset.open = "true";
        this.button.innerHTML = "Show less";
      } else {
        // close
        this.contentWrapper.style.height = `${this.previewHeight}px`;
        this.dataset.open = "false";
        this.button.innerHTML = "Show more +";
        this.scrollIntoView({ behaviour: "smooth" });
      }
    }
  }


  customElements.define('show-more', ShowMore);
}
